export default __webpack_public_path__ + "static/media/hotel-resort-img-20.b3d08f57.png";